import { render, staticRenderFns } from "./VdsBillDetail.vue?vue&type=template&id=77d0e7d0&scoped=true&"
import script from "./VdsBillDetail.vue?vue&type=script&lang=js&"
export * from "./VdsBillDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d0e7d0",
  null
  
)

export default component.exports